import UserAdTypes from './constants'

const initialState = {
  listData: {},
  item: {},
  type: UserAdTypes.LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
  listUsers: [],
  listLuong: []
}

const reducer = function adminUserReducer (state = initialState, action) {
  switch (action.type) {
    case UserAdTypes.LOAD_USERS:
      return {
        ...state,
        formData: action.payload
      }
    case UserAdTypes.SET_USERS:
      return {
        ...state,
        listUsers: action.payload
      }
    case UserAdTypes.LOAD_LUONG_CO_BAN:
      return {
        ...state,
        formData: action.payload
      }
    case UserAdTypes.SET_LUONG_CO_BAN:
      return {
        ...state,
        listLuong: action.payload
      }
    case UserAdTypes.LIST_REQUESTING:
      return {
        ...state,
        listData: [],
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang lấy dữ liệu, vui lòng chờ trong giây lát...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
      }

    case UserAdTypes.LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listData: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case UserAdTypes.LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listData: [],
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case UserAdTypes.ITEM_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [{
          body: 'Đang lấy dữ liệu, vui lòng chờ trong giây lát...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
      }

    case UserAdTypes.ITEM_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.data,
        type: action.type,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case UserAdTypes.ITEM_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: {},
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case UserAdTypes.ITEM_ADD_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [{
          body: 'Đang gửi dữ liệu, vui lòng chờ trong giây lát...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
      }

    case UserAdTypes.ITEM_ADD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.data,
        type: action.type,
        requesting: false,
        successful: true,
        messages: [{
          body: action.message,
          time: new Date(),
        }],
        errors: [],
      }

    case UserAdTypes.ITEM_ADD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case UserAdTypes.ITEM_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [{
          body: 'Đang gửi dữ liệu, vui lòng chờ trong giây lát...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
      }

    case UserAdTypes.ITEM_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.data,
        type: action.type,
        requesting: false,
        successful: true,
        messages: [{
          body: action.message,
          time: new Date(),
        }],
        errors: [],
      }

    case UserAdTypes.ITEM_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case UserAdTypes.ITEM_REMOVE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
      }

    case UserAdTypes.ITEM_REMOVE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload,
          time: new Date(),
        }],
        errors: [],
      }

    case UserAdTypes.ITEM_REMOVE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.payload.toString(),
          time: new Date(),
        }],
      }

    case UserAdTypes.SET_MESSAGE:
      return {
        ...state, // ensure that we don't erase fetched ones
        messages: [{
          body: action.payload,
          time: new Date().getTime(),
        }],
      }

    case UserAdTypes.SET_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        errors: [{
          body: action.payload,
          time: new Date().getTime(),
        }],
      }
    case UserAdTypes.SET_FORM_MESSAGES:
      return {
        ...state, // ensure that we don't erase fetched ones
        errors: [{
          body: action.payload,
          time: new Date().getTime(),
        }],
      }

    case UserAdTypes.RESET_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        errors: [],
      }

    case UserAdTypes.SET_DATA_TO_PROPS:
      state.item[action.payload.name] = action.payload.data;
      return {
        ...state, // ensure that we don't erase fetched ones
        item: state.item
      }

    case UserAdTypes.SET_DATA_TO_USER:
        state.item.user = state.item.user || {}
      state.item.user = Object.assign(state.item.user, action.payload);
      return {
        ...state, // ensure that we don't erase fetched ones
        item: state.item
      }

    case UserAdTypes.RESET_DATA:
      let { item } = state;
      item.user = {};
      item.permissions = [];
      item.khoids = [];
      return {
        ...state, // ensure that we don't erase fetched ones
        item: item
      }
    
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Admin/UserAd/reducer.js